import gsap, { Cubic } from 'gsap';

const ease = Cubic.easeInOut();

export const animateIn = ({ timeline, refs, onStart, onComplete }) => {
  const {
    wrapperRef,
    promoRef,
    searchBarRef,
    filtersRef,
    // searchCardsRef,
    resultsHeaderRef,
    selectedFiltersRef,
    resultsRef,
  } = refs?.current || {};

  timeline.current?.kill();
  timeline.current = gsap.timeline({
    onStart,
    onComplete,
    delay: 0.2,
  });

  // const [firstCard, secondCard] = searchCardsRef.current?.children || [];

  timeline.current
    .fromTo(
      wrapperRef?.current,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 0.3,
        delay: 0.5,
        ease,
      },
    )
    .fromTo(
      filtersRef.current?.children,
      {
        opacity: 0,
        x: 25,
      },
      {
        opacity: 1,
        x: 0,
        duration: 0.4,
        stagger: 0.1,
        ease,
      },
      'together',
    )
    .fromTo(
      promoRef.current?.children,
      {
        opacity: 0,
        y: 12,
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.4,
        stagger: 0.1,
        ease,
      },
      'together',
    )
    .fromTo(
      searchBarRef.current,
      {
        opacity: 0,
        scale: 0.98,
        y: 10,
        x: -10,
      },
      {
        opacity: 1,
        scale: 1,
        y: 0,
        x: 0,
        duration: 0.6,
        ease,
      },
      'together',
    )
    .fromTo(
      selectedFiltersRef.current?.children,
      {
        opacity: 0,
        x: 25,
      },
      {
        opacity: 1,
        x: 0,
        duration: 0.4,
        stagger: 0.1,
        delay: 0.3,
        ease,
      },
      'together',
    )
    .fromTo(
      resultsRef.current,
      {
        opacity: 0,
        y: 45,
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.7,
        delay: 0.5,
        ease,
      },
      'together',
    )
    // .fromTo(
    //   [firstCard, secondCard],
    //   {
    //     opacity: 0,
    //     y: 20,
    //   },
    //   {
    //     opacity: 1,
    //     y: 0,
    //     duration: 0.6,
    //     delay: 0.9,
    //     stagger: 0.1,
    //     ease,
    //   },
    //   'together',
    // )
    .fromTo(
      resultsHeaderRef.current?.children,
      {
        opacity: 0,
        y: 25,
      },
      {
        opacity: 1,
        y: 0,
        duration: 0.5,
        stagger: 0.1,
        delay: 0.6,
        ease,
      },
      'together',
    );
};

export const animateOut = ({ timeline, refs, onComplete }) => {
  const { wrapperRef, searchCardsRef, resultsHeaderRef, resultsRef } =
    refs?.current || {};

  timeline.current?.kill();
  timeline.current = gsap.timeline({
    onComplete,
    delay: 0.2,
  });

  const currentY = gsap.getProperty(resultsRef.current, 'y') || 0;

  timeline.current
    .to(
      wrapperRef?.current,
      {
        opacity: 0,
        duration: 0.3,
        delay: 0.5,
        ease,
      },
      'together',
    )
    .to(
      resultsRef.current,
      {
        opacity: 0,
        y: currentY + 45,
        duration: 0.7,
        delay: 0.5,
        ease,
      },
      'together',
    )
    .to(
      searchCardsRef.current?.children,
      {
        opacity: 0,
        y: 20,
        duration: 0.6,
        delay: 0.2,
        stagger: 0.1,
        ease,
      },
      'together',
    )
    .to(
      resultsHeaderRef.current?.children,
      {
        opacity: 0,
        y: 25,
        duration: 0.5,
        stagger: 0.1,
        delay: 0.3,
        ease,
      },
      'together',
    );
};
